import { render } from "./App.vue?vue&type=template&id=aca732b2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@/assets/style.css?vue&type=style&index=0&lang=css"
import "@/assets/custom.css?vue&type=style&index=1&lang=css"
import "@/assets/animation.css?vue&type=style&index=2&lang=css"
import "./App.vue?vue&type=style&index=3&id=aca732b2&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__